/* esm.sh - applesauce-core@5.2.0/helpers/encryption */
import{nip04 as s,nip44 as u}from"nostr-tools";function f(n){let o=n.length;return o<28?!1:n[o-28]=="?"&&n[o-27]=="i"&&n[o-26]=="v"&&n[o-25]=="="}export{f as isNIP04Encrypted,s as nip04,u as nip44};
//# sourceMappingURL=encryption.mjs.map